import { API } from "./APIClient";
import qs from "qs";
import { getCurrentUserId } from "../utils/reduxUser";

class TableAPIClass {
    _toISODate(value) {
        if (!value) return value;
        if (value instanceof Date) return value.toISOString().split("T")[0];
        if (typeof value === "string") return value;
        return new Date(value).toISOString().split("T")[0];
    }

    _mapShiftInfoResponse(data) {
        const result = [];
        for (const item of data.emp_lst || []) {
            result.push({
                employee: {
                    userId: item.emp.user_id,
                    name: item.emp.name,
                    cafeId: item.emp.cafe_id,
                    level: item.emp.level,
                    totalExp: item.emp.total_exp,
                    registeredAt: item.emp.registered_at,
                    profilePhoto: item.emp.profile_photo_url,
                },
                startTime: item.start_time,
                endTime: item.end_time,
            });
        }
        return result;
    }

    async fetchShifts(cafeId, year, month) {
        const userId = getCurrentUserId();

        const query = qs.stringify({
            cafe_id: cafeId,
            employee_id: userId,
            year,
            month
        })

        const response = await API.get(`/schedule/employeeShifts?${query}`);

        const result = [];
        for (const item of response.data.shift_list) {
            result.push({
                employeeId: item.employee_id,
                cafeId: item.cafe_id,
                shiftDate: item.shift_date,
                startTime: item.start_time,
                endTime: item.end_time,
            })
        }

        return result;
    }

    async fetchTotalShifts(year = new Date().getFullYear(), month = new Date().getMonth() + 1) {
        const userId = getCurrentUserId();

        const query = qs.stringify({
            year,
            month
        })

        const response = await API.get(`/schedule/employeeTotalShifts/${userId}?${query}`);

        return {
            shifts: response.data.total_shifts,
            hours: response.data.total_hours,
        };
    }

    async fetchShiftInfo(cafeId, shiftDate) {
        const query = qs.stringify({
            cafe_id: cafeId,
            shift_date: this._toISODate(shiftDate),
        });

        const response = await API.get(`/schedule/shifInfo?${query}`);
        return this._mapShiftInfoResponse(response.data);
    }

    async fetchShiftsMonthly(cafeId, year, month) {
        const query = qs.stringify({
            year,
            month,
        });

        const response = await API.get(`/schedule/${cafeId}/shiftsMonthly?${query}`);

        const result = [];
        for (const item of response.data.shift_list) {
            result.push({
                shiftDate: item.shift_date,
                countEmployees: item.count_employees,
            });
        }

        return result;
    }



    async fetchAdminShiftInfo(cafeId, shiftDate) {
        const query = qs.stringify({
            cafe_id: cafeId,
            shift_date: this._toISODate(shiftDate),
        })

        const response = await API.get(`/admin/schedule/shifInfo?${query}`);
        return this._mapShiftInfoResponse(response.data);
    }

    async fetchAdminShiftsMonthly(cafeId, year, month) {
        const query = qs.stringify({
            year,
            month
        })

        const response = await API.get(`/admin/schedule/${cafeId}/shiftsMonthly?${query}`);

        const result = [];
        for (const item of response.data.shift_list) {
            result.push({
                shiftDate: item.shift_date,
                countEmployees: item.count_employees,
            });
        }

        return result;
    }

    async createShift(cafeId, empId, shiftDate, startTime, endTime) {
        const response = await API.post(`/admin/schedule/createShift`, {
            cafe_id: cafeId,
            employee_id: empId,
            shift_date: this._toISODate(shiftDate),
            start_time: startTime,
            end_time: endTime,
        });

        return response.data;
    }

    async bulkCreateShifts(cafeId, employeeIds, shiftDates, startTime, endTime) {
        const normalizedDates = (shiftDates || []).map(d => this._toISODate(d));

        const response = await API.post(`/admin/schedule/bulkCreateShifts`, {
            cafe_id: cafeId,
            employee_ids: employeeIds,
            shift_dates: normalizedDates,
            start_time: startTime,
            end_time: endTime,
        });

        return {
            createdCount: response.data.created_count,
            updatedCount: response.data.updated_count,
            createdShifts: (response.data.created_shifts || []).map(item => ({
                id: item.id,
                cafeId: item.cafe_id,
                employeeId: item.employee_id,
                shiftDate: item.shift_date,
                startTime: item.start_time,
                endTime: item.end_time,
                createdAt: item.created_at,
            })),
        };
    }

    async cancelShift(cafeId, empId, shiftDate) {
        const query = qs.stringify({
            cafe_id: cafeId,
            shift_date: this._toISODate(shiftDate),
            employee_id: empId,
        })

        const response = await API.delete(`/admin/schedule/cancelShift?${query}`);

        return response.data;
    }

    async fetchEmployeeShifts(userId, cafeId, year, month) {
        const query = qs.stringify({
            cafe_id: cafeId,
            employee_id: userId,
            year,
            month
        })

        const response = await API.get(`/admin/schedule/employeeShifts?${query}`);

        const result = [];
        for (const item of response.data.shift_list) {
            result.push({
                employeeId: item.employee_id,
                cafeId: item.cafe_id,
                shiftDate: item.shift_date,
                startTime: item.start_time,
                endTime: item.end_time,
            })
        }

        return result;
    }

    async fetchEmployeeTotalShifts(userId, year = new Date().getFullYear(), month = new Date().getMonth() + 1) {
        const query = qs.stringify({
            year,
            month
        })

        const response = await API.get(`/admin/schedule/employeeTotalShifts/${userId}?${query}`);

        return {
            shifts: response.data.total_shifts,
            hours: response.data.total_hours,
        };
    }
}

const TableAPI = new TableAPIClass();
export default TableAPI;
